import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { NumberInput } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface ParticipationRateFormFieldProps {
  input?: Partial<React.ComponentProps<typeof NumberInput>>
}

export const ParticipationRateFormField: React.FC<ParticipationRateFormFieldProps> = ({
  input,
}) => {
  const { control, register } = useFormContext<{ participation_rate: number }>()

  return (
    <FormField
      name="participation_rate"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Participation Rate</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput
              {...register('participation_rate')}
              placeholder={'Enter the participation rate'}
              {...input}
            />
          </FormItem>
        )
      }}
    />
  )
}
